import methods from '../methods'

const API_URL = '/api'

const getFields = () => methods.GET_API(`${API_URL}/fields`)

export default {
  getFields
}
